<template>
    <main class="library body">
        <primary-navigation />
        <div class="constrain bc" v-if="publisher && publisher.data && publisher.data.news_snippet">
            <div class="news">
                <div class="flex flex-align">
                    <div class="news-metadata">
                        <h3 class="news-headline">What's New</h3>
                        <h4 class="news-updated-date" v-if="publisher.data.news_updated_date">Updated {{ publisher.data.news_updated_date }}</h4>
                        <div class="news-snippet">{{ publisher.data.news_snippet }}</div>
                    </div>
                    <div class="ff"></div>
                    <div class="flex flex-end" v-if="publisher.data.news_url">
                        <a class="news-url flex flex-align" :href="publisher.data.news_url" target="_blank">
                            Read More News
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-right" width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z"/>
                                <line x1="5" y1="12" x2="19" y2="12" />
                                <line x1="13" y1="18" x2="19" y2="12" />
                                <line x1="13" y1="6" x2="19" y2="12" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="library-header-container">
            <div class="flex flex-align library-header">
                <h1 class="favorites">My Library</h1>
                <div class="sort-placeholder" @click="sortFavorites"></div>
            </div>
        </div>
        <div class="library-products">
            <template v-if="products.length">
                <template v-if="favorites.length">
                    <div class="products flex flex-wrap" style="margin-top: 1em;">
                        <router-link class="product block" v-for="variation in favorites" :key="variation.id" :to="{name: 'product', params: {product: variation.id}}">
                            <div class="product-cover oh">
                                <img :src="variation.product.data.background.thumbnail" v-if="variation.product.data.background.thumbnail" />
                                <img :src="variation.product.data.background.cover" v-else-if="variation.product.data.background.cover" />
                            </div>
                            <div class="product-title">{{ variation.product.title }}</div>
                        </router-link>
                        <div class="product ff" v-for="i in [1, 2, 3, 4, 5]" :key="i"></div>
                    </div>
                </template>
                <div class="library-header-container">
                    <div class="flex flex-align library-header">
                        <h1 class="available">Available At My School</h1>
                    </div>
                </div>
                <div class="filter-container constrain bc" style="margin-top: 0.25in;">
                    <tag class="pl-4" @tag-clicked="tagSelect" :tags="tagList" :activeId="tagSelected"/>
                    <div class="sort-placeholder2" @click="sortProducts"></div>
                </div>
                <div class="products flex flex-wrap">
                    <router-link class="product block" v-for="variation in products" :key="variation.id" :to="{name: 'product', params: {product: variation.id}}">
                        <div class="product-cover oh">
                            <img :src="variation.product.data.background.thumbnail" v-if="variation.product.data.background.thumbnail" />
                            <img :src="variation.product.data.background.cover" v-else-if="variation.product.data.background.cover" />
                        </div>
                        <div class="product-title">{{ variation.product.title }}</div>
                    </router-link>
                    <div class="product ff" v-for="i in [1, 2, 3, 4, 5]" :key="i"></div>
                </div>
            </template>
            <div class="ff library-empty" v-else>
                <h1 class="center bc">Nothing to show here.</h1>
                <div class="filter-container">
                    <tag class="pl-4" @tag-clicked="tagSelect" :tags="tagList" :activeId="tagSelected"/>
                    <div @click="sortProducts" class="sort-placeholder"></div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import _ from 'lodash';
import Options from '@/components/modals/Options.vue';
import Tag from '@/components/Tag.vue';

const sorters = {
    alphabetical: (a, b) => a.product.title.trim().localeCompare(b.product.title.trim(), undefined, { numeric: true, sensitivity: 'base' }),
    recentupdated: (a, b) => new Date(b.product.dateUpdated) - new Date(a.product.dateUpdated)
};

export default {
    name: 'Library',
    data() {
        return {
            filter: 'alphabetical',
            tagSelected: '',
            tagList: [
                { title: 'All', id: '' }
            ]
        };
    },
    components: {
        Tag,
        Options
    },
    mounted() {
        if (this.user && this.user.session && this.user.session.id) {
            this.$store.dispatch('sessions/extendLoginSession', this.user.session.id);
        }
    },
    methods: {
        sortFavorites() {
            console.log("Sort button clicked for My Library");
            const _this = this;
            this.$modal.show(Options, {
                title: 'Sort Products',
                options: [
                    { color: 'blue', title: 'Alphabetical', fn() { _this.filter = 'alphabetical'; } },
                    { color: 'blue', title: 'Recently Updated', fn() { _this.filter = 'recentupdated'; } }
                ]
            },
            {
                width: 260,
                height: 'auto',
                classes: 'modal'
            });
        },
        sortProducts() {
            console.log("Sort button clicked for Available At My School");
            const _this = this;
            this.$modal.show(Options, {
                title: 'Sort Products',
                options: [
                    { color: 'blue', title: 'Alphabetical', fn() { _this.filter = 'alphabetical'; } },
                    { color: 'blue', title: 'Recently Updated', fn() { _this.filter = 'recentupdated'; } }
                ]
            },
            {
                width: 260,
                height: 'auto',
                classes: 'modal'
            });
        },
        tagSelect(event) {
            this.tagSelected = event.id || '';
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        publisher() {
            return this.$store.getters.publisher;
        },
        products() {
            return this.$store.getters.products.slice()
                .filter(variation => variation.product)
                .sort(sorters[this.filter])
                .filter(data => {
                    if (!this.filterTags) return true;

                    if (!data.product.tags) {
                        console.error('Tag filter is disabled due to tags not being available on the list');
                        return true;
                    }

                    if (typeof data.product.tags !== 'object') return false;
                    var filtered = data.product.tags.filter(filter => {
                        if (this.tagList.filter(list => list.id === filter.id).length === 0) {
                            this.tagList.push(filter);
                        }
                        return (filter.id === this.tagSelected);
                    });

                    if (this.tagSelected === '') return true;
                    return typeof data.product.tags === 'object' && filtered.length > 0;
                });
        },
        favorites() {
            return this.products.filter(product => {
                if (_.get(product, 'progress.data.favorite')) {
                    return true;
                }
                return _.get(product, 'membership.person.id') === this.user.id;
            });
        },
        filterTags() {
            return true;
        }
    }
};
</script>

<style scoped lang="less">
@import "~@/assets/less/variables";

@width: 270px;

.library {
    min-height: 100vh;
}

.library-header-container {
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 30px;
    padding-top: 1.0in; /* 1.0 inch white space on top */
}

.library-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 1.5rem;
}

.sort-placeholder, .sort-placeholder2 {
    width: 32px;
    height: 32px;
    background: url('~@/assets/icons/base/sort.svg') center center no-repeat;
    background-size: 24px auto;
    cursor: pointer;
    margin-right: 10px; /* Adjust this value to move the sorting icon to the left */
    margin-left: -100px; /* Adjust to move to the left */
}

.products {
    max-width: 1300px;
    padding: 0 30px;
    margin: 0 auto;
}

.product {
    width: @width;
    max-width: @width;
    min-width: @width;
    flex-basis: @width;
    margin: 20px;
    cursor: pointer;

    .product-cover {
        width: @width;
        height: 340px;
        border-radius: 6px;
        box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.25);
        transition: all ease 0.35s;

        img {
            width: @width;
            height: 340px;
            object-fit: cover;
            pointer-events: none;
        }
    }

    .product-title {
        color: @black;
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        padding: 0 20px;
        margin-top: 18px;
    }

    &:hover, &:active {
        .product-cover {
            box-shadow: 0 6px 30px -2px rgba(0, 0, 0, 0.35);
            transform: translate3d(0, -8px, 0);
        }
    }
}

.news {
    border-top: 1px solid @e4;
    border-bottom: 1px solid @e4;
    margin-top: 50px;
    padding: 30px 0;
}

.news-metadata {
    max-width: 700px;
}

.news-headline {
    font-size: 24px;
}

.news-updated-date {
    margin-top: 0;
    color: @grey;
}

.news-snippet {
    color: @black;
    margin: 10px 0 15px;
    line-height: 20px;
    font-size: 15px;
}

.news-url {
    color: @base;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    transition: opacity ease 0.2s;
    margin-left: 30px;

    svg {
        margin-left: 4px;
    }

    &:hover, &:active {
        opacity: 0.7;
    }
}

.filter-container {
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
    margin-top: 0.25in; /* Added margin-top to create space */
}

.p-4 {
    padding: 1.5em;
}

.pr-4 {
    padding-right: 1.5em;
}

.pl-4 {
    padding-left: 1.5em;
}

.favorites {
    margin-left: 0; /* Align the header with the left side */
}

.available {
    margin-left: 0; /* Align the header with the left side */
}
@media print {
    .body * {
        visibility: hidden;
    }

    .body:after {
        content: "Printing is disabled.";
        visibility: visible;
        display: block;
        text-align: center;
        font-size: 20px;
        margin-top: 50vh;
        transform: translateY(-50%);
    }
}
</style>
